import LeaveRequests from "../../Component/Vacations/Vacations";

function Vacations() {
  return  <LeaveRequests />
     
}

export default Vacations;
